import React from "react";
import PropTypes from "prop-types";

const FacebookIcon = ({ className, color }) => (
  <svg
    className={className}
    x="0px"
    y="0px"
    viewBox="0 0 19 35.4"
    xmlSpace="preserve"
  >
    <path
      d="M17.7,19.9l1-6.4h-6.1V9.3c0-1.8,0.9-3.5,3.6-3.5H19V0.4c0,0-2.5-0.4-5-0.4C8.9,0,5.6,3.1,5.6,8.6v4.9H0v6.4h5.6v15.5h6.9 V19.9H17.7z"
      fill={color}
    />
  </svg>
);

FacebookIcon.defaultProps = {
  className: ``,
  color: `white`
};

FacebookIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default FacebookIcon;
